import { observer } from "mobx-react-lite";
import styled from "@emotion/styled";
import { useAppStore } from "@/store";
import { FC } from "react";
import { SyncAvatarIndicator } from "@/components/sync/sync-avatar-indicator";
import { AccountProfileImage } from "@/components/layout/components/account-profile/account-profile-image";

interface TopBarProfileImageProps {
  togglePopUpBar: () => void;
}

export const TopBarProfileImage: FC<TopBarProfileImageProps> = observer(({ togglePopUpBar }) => {
  const { store } = useAppStore();
  const { profileDisplayName, profilePhotoUrl } = store.account.myAccount;

  return (
    <ProfileImageContainer onClick={togglePopUpBar}>
      <SyncAvatarIndicator syncState={store.sync.syncState}>
        <AccountProfileImage
          size={24}
          photoUrl={profilePhotoUrl}
          displayName={profileDisplayName}
        />
      </SyncAvatarIndicator>
    </ProfileImageContainer>
  );
});

const ProfileImageContainer = styled.div(({ theme }) => ({
  cursor: "pointer",
  margin: theme.spacing["2"],
  WebkitAppRegion: "no-drag",
}));
